<section class="funfacts-area">
    <div class="container">
        <div class="funfacts-list">
            <div class="funfact">
                <i class="far fa-smile"></i>
                <div class="funfact-content">
                    <h3><span [countUp]="30000">00</span></h3>
                    <p>Familias Intervenidas</p>
                </div>
            </div>
            <div class="funfact">
                <i class="fas fa-shield-alt"></i>
                <div class="funfact-content">
                    <h3><span [countUp]="15">00</span></h3>
                    <p>Proyectos Completados</p>
                </div>
            </div>
            <div class="funfact">
                <i class="fas fa-award"></i>
                <div class="funfact-content">
                    <h3><span [countUp]="12">00</span></h3>
                    <p>Premios Obtenidos</p>
                </div>
            </div>
            <div class="funfact">
                <i class="fas fa-user"></i>
                <div class="funfact-content">
                    <h3><span [countUp]="34">00</span></h3>
                    <p>Miembros</p>
                </div>
            </div>
        </div>
    </div>
</section>
